import React, { Component } from 'react'
import { func, string, array } from 'prop-types'
import './PostalCodePicker.css'

class PostalCodePickerComponent extends Component {
  constructor (props) {
    super(props)
    this.state = { open: false }
    this.rootNode = null
    var self = this
    this.setRef = function (el) { self.rootNode = el }
    this.toggle = this.toggle.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside (e) {
    if (this.rootNode && !this.rootNode.contains(e.target)) {
      this.setState({ open: false })
    }
  }

  toggle () {
    this.setState(function (s) { return { open: !s.open } })
  }

  handleSelect (code) {
    this.props.onChange(code)
    this.setState({ open: false })
  }

  render () {
    var selected = this.props.selected
    var codes = this.props.postalCodes || []
    var open = this.state.open
    var self = this

    return (
      <div className="cp-picker" ref={this.setRef}>
        <button
          className={'cp-picker__trigger' + (open ? ' cp-picker__trigger--open' : '')}
          onClick={this.toggle}
          type="button"
        >
          <svg className="cp-picker__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          <span>{selected}</span>
          <svg className={'cp-picker__chevron' + (open ? ' cp-picker__chevron--open' : '')} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
        {open && (
          <div className="cp-picker__dropdown">
            {codes.map(function (code) {
              var isSelected = code === selected
              return (
                <button
                  key={code}
                  className={'cp-picker__option' + (isSelected ? ' cp-picker__option--selected' : '')}
                  onClick={function () { self.handleSelect(code) }}
                  type="button"
                >
                  <span>{code}</span>
                  {isSelected && (
                    <svg className="cp-picker__tick" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </button>
              )
            })}
          </div>
        )}
      </div>
    )
  }
}

PostalCodePickerComponent.propTypes = {
  postalCodes: array,
  selected: string,
  onChange: func
}

export var PostalCodePicker = PostalCodePickerComponent



// WEBPACK FOOTER //
// ./src/components/gardeners/PostalCodePicker.js